export function getError(values) {
  const latitudeMessage = () => {
    if (values.latitude.length === 0 || values.latitude === "") {
      return {
        isError: true,
        message: "This field cannot be empty"
      };
    } else {
      return {
        isError: false,
        message: null
      };
    }
  };

  const longitudeMessage = () => {
    if (values.longitude.length === 0 || values.longitude === "") {
      return {
        isError: true,
        message: "This field cannot be empty"
      };
    } else {
      return {
        isError: false,
        message: null
      };
    }
  };

  const nameMessage = () => {
    if (values.name.length === 0 || values.name === "") {
      return {
        isError: true,
        message: "This field cannot be empty"
      };
    } else {
      return {
        isError: false,
        message: null
      };
    }
  };

  const remarksMessage = () => {
    if (values.remarks.length === 0 || values.remarks === "") {
      return {
        isError: true,
        message: "This field cannot be empty"
      };
    } else {
      return {
        isError: false,
        message: null
      };
    }
  };

  return {
    latitude: latitudeMessage(),
    longitude: longitudeMessage(),
    name: nameMessage(),
    remarks: remarksMessage()
  };
}

export async function hasNoError(errors) {
  if (
    errors.latitude.isError === false &&
    errors.longitude.isError === false &&
    errors.name.isError === false &&
    errors.remarks.isError === false
  ) {
    return true;
  } else {
    return false;
  }
}
